var map = {
	"./AI_ML.jpg": 128,
	"./BAPS.png": 129,
	"./CommoditiesHealthFood.jpg": 130,
	"./HX.jpg": 131,
	"./MITx.jpg": 132,
	"./NYIT_logo.png": 133,
	"./U-M_Logo.png": 134,
	"./ZeroLabz.png": 135,
	"./Zerol0l.png": 136,
	"./address_image.svg": 137,
	"./animated_logo.svg": 138,
	"./blogs_image.svg": 139,
	"./cloud_infrastructure.svg": 140,
	"./codeInLogo.png": 141,
	"./contactMail.png": 142,
	"./coursera_logo.png": 143,
	"./data_science.svg": 144,
	"./deeplearning_ai_logo.png": 145,
	"./delhivery_logo.png": 146,
	"./developerActivity.svg": 147,
	"./dsc_logo.png": 148,
	"./education.svg": 149,
	"./experience.svg": 150,
	"./feelingProud.svg": 151,
	"./freecopy_logo.png": 152,
	"./fullstack.svg": 153,
	"./gcp_logo.png": 154,
	"./github_logo.png": 155,
	"./googleAssistant.jpg": 156,
	"./googleAssistant.svg": 157,
	"./google_logo.png": 158,
	"./ibm_logo.png": 159,
	"./iiitk_logo.png": 160,
	"./intel_logo.jpg": 161,
	"./iu_logo.png": 162,
	"./jsFramework.svg": 163,
	"./legato_logo.png": 164,
	"./manOnTable.svg": 165,
	"./microsoft_logo.png": 166,
	"./mozilla_logo.png": 167,
	"./muffito_logo.png": 168,
	"./nextuLogo.jpg": 169,
	"./nptel_logo.png": 170,
	"./portfolio.gif": 171,
	"./programmer.svg": 172,
	"./projects_image.svg": 173,
	"./pwa.png": 174,
	"./saayaHealthLogo.png": 175,
	"./stanford_logo.png": 176,
	"./talksCardBack.svg": 177,
	"./talksCardBackAlt.svg": 178,
	"./tiktok_logo.png": 179,
	"./ui_ux_design.svg": 180
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;